import { Calendar1 } from "lucide-react";

const interviews = [
  {
    title: "Interview for UX Designer at Search Co",
    timing: "10:00 - 10:30, 01/11/25",
  },
  {
    title: "Meeting with Recruiter for Project Manager",
    timing: "10:00 - 10:30, 01/11/25",
  },
  {
    title: "Interview for UX Designer at Search Co",
    timing: "10:00 - 10:30, 01/11/25",
  },
  {
    title: "Meeting with Recruiter for Project Manager",
    timing: "10:00 - 10:30, 01/11/25",
  },
  {
    title: "Interview for UX Designer at Search Co",
    timing: "10:00 - 10:30, 01/11/25",
  },
  {
    title: "Meeting with Recruiter for Project Manager",
    timing: "10:00 - 10:30, 01/11/25",
  },
  {
    title: "Interview for UX Designer at Search Co",
    timing: "10:00 - 10:30, 01/11/25",
  },
  {
    title: "Meeting with Recruiter for Project Manager",
    timing: "10:00 - 10:30, 01/11/25",
  },
];

const UpcomingInterviews = () => {
  return (
    <div className="flex flex-col w-[45%]">
      <div className="flex items-center justify-between">
        <span className="font-bold text-primary text-sm">
          Upcoming Interviews
        </span>
        <button className="text-xs text-blue-500 font-semibold">
          View All
        </button>
      </div>
      {/* List Section */}
      <div className="mt-5 flex flex-col gap-5 min-h-0 overflow-y-scroll no-scrollbar">
        {interviews?.map((interview, interviewIndex) => {
          return (
            <div key={interviewIndex} className="flex items-center gap-3.5">
              <div className="flex items-center justify-center w-11 h-11 rounded-md bg-gray-100">
                <Calendar1 className="w-5 h-5" />
              </div>
              <div className="flex flex-col justify-between flex-1 gap-2">
                <span className="text-xs text-primary font-medium">
                  {interview?.title}
                </span>
                <span className="text-xs text-light-black">{interview?.timing}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default UpcomingInterviews;
